import { DialogAction } from "./dialog-action";

export class DialogData {
	dialogType: "info" | "warning" = "info";
	titleKey: string | undefined;
	messageKey: string | undefined;
	messageParams: object | undefined;
	message: string | undefined;
	prompt: string | undefined;
	footerKey: string | undefined;
	actions: DialogAction[] | undefined;
	/**
	 * @deprecated TODO not in use; Angular ignores any attempts to move focus, so put the default action first in the actions list
	 */
	defaultActionId: string | undefined;
}
